import './mocks/seedFirst'; // deve vir ANTES de ./App (semeia sessão mock). No-op sem REACT_APP_MOCK.
import React from 'react';
import ReactDOM from 'react-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./assets/scss/main.scss"

// O board de Painéis arrasta cards entre etapas com react-dnd; o provider fica
// na raiz para o layer de arraste conviver com o resto da aplicação.
ReactDOM.render(
  <React.StrictMode>
    <DndProvider backend={HTML5Backend}>
      <App />
    </DndProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
